import React from 'react'
import { Nav, NavItem, NavLink } from 'reactstrap'
import tapOrClick from 'react-tap-or-click'
import '../../../stylesheets/odometer-theme-default.css'
import ExtendIcon from 'react-icons/lib/fa/expand'
import EditPlanIcon from 'react-icons/lib/fa/edit'
import AddPlanIcon from 'react-icons/lib/fa/plus-square'
import SubsListIcon from 'react-icons/lib/fa/list'
import classnames from 'classnames'
import '../../../stylesheets/ControllerDashboard.css'
import { authRedirect } from "../../../dataHelpers/authenticationHelpers"
import { AddSubscription } from "./"

class SubscriptionSetting extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            activeTab: '1',
            errors: []
        }
    }

    render() {

        return (<div>
            <div className="m-0 p-0">
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '1' })}
                        >
                            <AddPlanIcon />&ensp;Create Plan
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '2' })}
                            {...tapOrClick(() => { (authRedirect(`/management/controllers/subscriptioninitialplan`, this.props.history)) })}
                        >
                            <EditPlanIcon />&ensp;Edit Plan
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '3' })}
                            {...tapOrClick(() => { (authRedirect(`/management/controllers/subscriptionsetting/extendsubscription`, this.props.history)) })}>
                            <ExtendIcon />&ensp;Extend Plan
                            </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '4' })}
                            {...tapOrClick(() => { (authRedirect(`/management/controllers/subscriptionplanlist`, this.props.history)) })}>
                            <SubsListIcon />&ensp;Available Plans
                            </NavLink>
                    </NavItem>
                </Nav>
            </div>
            <AddSubscription />
        </div>)
    }
}
export default SubscriptionSetting



// WEBPACK FOOTER //
// ./src/components/pages/subscription/SubscriptionSetting.js